import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import AdminNewsletterTemplatesNav from "./nav"
import AuditsPage from "components/admin/audits/page"
import memo from "set-state-compare/build/memo"
import {NewsletterTemplate} from "models"
import React from "react"
import {useAdminLayout} from "components/admin/layout"
import useModel from "@kaspernj/api-maker/build/use-model"
import {View} from "react-native"

/**
 * @typedef {object} RoutesAdminNewsletterTemplateAuditsProps
 * @property {unknown} match
 */

/** @typedef {object} RoutesAdminNewsletterTemplateAuditsState */

/**
 * @extends {ShapeComponent<RoutesAdminNewsletterTemplateAuditsProps, RoutesAdminNewsletterTemplateAuditsState>}
 */
class RoutesAdminNewsletterTemplateAudits extends ShapeComponent {
  setup() {
    const {newsletterTemplate} = useModel(NewsletterTemplate, {match: this.p.match})

    this.newsletterTemplate = newsletterTemplate

    useAdminLayout()?.setState({active: "newsletter-templates", headerTitle: NewsletterTemplate.humanAttributeName("audits")})
  }

  render() {
    const {newsletterTemplate} = this.tt

    return (
      <View dataSet={{route: "admin/newsletter-templates/audits"}}>
        {newsletterTemplate &&
          <>
            <AdminNewsletterTemplatesNav active="audits" className="mb-4" newsletterTemplate={newsletterTemplate} />
            <AuditsPage resource={newsletterTemplate} />
          </>
        }
      </View>
    )
  }
}

export default memo(shapeComponent(RoutesAdminNewsletterTemplateAudits))
